import {
  getMethod,
  download
} from './data'
import request from '@/utils/request'
//获取banner
export function getBanners(data) {
  return getMethod('/api/banner', data)
}
//获取课程
export function getCourse(data) {
  return getMethod('/api/course', data)
}
//课程类别
export function getCategory(data) {
  return getMethod('/api/category', data)
}

//我的课程
export function getMyCourse(data) {
  return getMethod('/api/course/my', data)
}
//课程详情
export function getCourseDetail(courseId) {
  let url = '/api/course/' + courseId.toString()
  return getMethod(url)
}
// 新增学习记录
export function addlearnedRecord(data) {
  return request({
    url: '/api/learnedRecord',
    method: 'post',
    data
  })
}
// 查询部门
export function getdept(data) {
  return getMethod('/api/dept', data)
}
// 查询部门
export function getusers(data) {
  return getMethod('/api/users', data)
}
//获取用户信息user/info
export function userinfo(data) {
  return request({
    url: '/api/users/info',
    method: 'put',
    data
  })
}
//新增订阅
export function userSubscribe(data) {
  return request({
    url: '/api/subscribe',
    method: 'post',
    data
  })
}
// 上传头像
export function usersUpdateAvatar(data) {
  return request({
    url: '/api/users/updateAvatar',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

//登录部分
//微信授权
export function wxSocial(data) {
  return request({
    url: '/auth/wxSocial',
    method: 'post',
    data
  })
}
//微信授权登录
export function wxLogin(data) {
  return request({
    url: '/auth/wxLogin',
    method: 'post',
    data
  })
}
//获取验证码
export function smsCode(data) {
  return getMethod('/auth/sms/code', data)
}
//短信验证码登录
export function smsLogin(data) {
  return request({
    url: '/auth/smsLogin',
    method: 'post',
    data
  })
}
// 保险种类
export function productType(params) {

  return request({
    url: 'api/productType',
    method: 'get',
    params
  })
}
//   api/company 保险公司
export function company(params) {

  return request({
    url: 'api/company',
    method: 'get',
    params
  })
}
///api/product 保险产品
export function product(params) {
  return getMethod('api/product', params)
  // return request({
  //   url: 'api/product',
  //   method: 'get',
  //   params
  // })
}
// 保单查询
export function policy(params) {

  return request({
    url: 'api/policy',
    method: 'get',
    params
  })
}
// 个人保单查询
export function queryAllByAgentIdOrBlurry(params) {

  return request({
    url: 'api/policy/queryAllByAgentIdOrBlurry',
    method: 'get',
    params
  })
}
// 退出登录
export function logout(params) {

  return request({
    url: 'auth/logout',
    method: 'delete',
    params
  })
}
// insurance 产品查询
export function insurance(params) {

  return request({
    url: 'api/insurance',
    method: 'get',
    params
  })
}
// 产品详情
export function insurancedetail(params) {

  return request({
    url: 'api/insurance/' + params,
    method: 'get',

  })
}
//  api/users/center 修改个人信息
export function usercenter(data) {
  return request({
    url: '/api/users/center',
    method: 'put',
    data
  })
}
// 展业轮播图
export function getcarousel(data) {
  return getMethod('/api/carousel', data)
}
// 获取播放凭证
export function getVideoPlayAuth(data) {
  return request({
    url: '/api/vod/getVideoPlayAuth/' + data,
    method: 'get'
  })
}